export class ImageModel {
  id: number;
  resourceId: string;
  resourceName: string;
  resourceUrl: string;

  constructor(
    id: number,
    resourceId: string,
    resourceName: string,
    resourceUrl: string,
  ) {
    this.id = id;
    this.resourceId = resourceId;
    this.resourceName = resourceName;
    this.resourceUrl = resourceUrl;
  }
}

export class ApplicationLink {
  id: number;
  sectionId: string;
  title: string;
  url: string;
  description: string;
  icon: any;
}

export class Section {
  id: number;
  layout: number;
  applicationLinks: ApplicationLink[];
  title: string;
}

export class WelcomeMessageModel {
  avatar: ImageModel;
  id: string;
  image: ImageModel;
  jobTitle: string;
  message: string;
  name: string;
  title: string;
}

export class SRMModel {
  welcomeMessage: WelcomeMessageModel;
  sections: Section[];
}

export class UrlModel {
  url: any;
  file: File | string;
}
